import { z } from 'zod'
import { paginationQuerySchema } from './api-response.ts'
import { timestampSchema, uuidSchema } from './common.ts'
import { roleSchema } from './roles.ts'

export const staffUserSchema = z.object({
  id: uuidSchema,
  email: z.email(),
  name: z.string().min(1),
  role: roleSchema,
  disabledAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
})

export type StaffUser = z.infer<typeof staffUserSchema>

export const createStaffUserSchema = z.object({
  email: z.string().trim().pipe(z.email()),
  name: z.string().min(1),
  role: roleSchema,
  password: z.string().min(12),
})

export type CreateStaffUser = z.infer<typeof createStaffUserSchema>

export const updateRoleSchema = z.object({
  role: roleSchema,
})

export type UpdateRole = z.infer<typeof updateRoleSchema>

export const setDisabledSchema = z.object({
  disabled: z.boolean(),
})

export type SetDisabled = z.infer<typeof setDisabledSchema>

export const staffListQuerySchema = paginationQuerySchema
export type StaffListQuery = z.infer<typeof staffListQuerySchema>
